import { useReactiveVar } from '@apollo/client';
import * as React from 'react';
import { templateInstanceFormEntriesVar } from '../../apollo/reactiveVariables/TemplateInstanceVariables';
import { getAppHost } from '../../utilities/TeamsUtils';
import { FormFacade } from '../facade';
import { useFormFacadeProps } from '../hooks';
import { FormContext, FormMode } from '../implementations';
import { noop } from '../shims';

export interface FormDesignAdapterProps extends React.HTMLAttributes<HTMLDivElement> {
    onFormReady?: () => void;
}

export const FormDesignAdapter: React.FC<FormDesignAdapterProps> = ({ onFormReady = noop, ...props }) => {
    const formFacadeProps = useFormFacadeProps({ compact: getAppHost().isMobile() });
    const entries = useReactiveVar(templateInstanceFormEntriesVar);
    const context = React.useMemo(() => ({ mode: FormMode.Designing, entries }), [entries]);
    const onContextChange = React.useCallback(
        (context: FormContext) => templateInstanceFormEntriesVar(context.entries),
        []
    );

    const onFormReadyRef = React.useRef(onFormReady);
    React.useEffect(() => onFormReadyRef.current(), []);

    return <FormFacade {...formFacadeProps} {...props} context={context} onContextChange={onContextChange} />;
};
